import { createContext } from "react";

export default createContext({
  userTypes: [],
  handleUserType: () => { },
  handleOpenSignInBox: () => { },
  videoInfo: {
    videoType: "",
    filmName: "",
    season: "",
    episode: "",
    videoFile: "",
    subtitleOneLanguage: "",
    subtitleOneFile: "",
    subtitleOneRtl: "",
    subtitleTwoLanguage: "",
    subtitleTwoFile: "",
    subtitleTwoOff: false,
    subtitleTwoRtl: "",
    // config:{}
  },
  handleVideoInfo: () => { },
  handleSubtitleContenet: () => { },
  subtitleOneContenet: "",
  handleSubtitleTimeShiftBox: () => { },
  subtitleTimeShiftBox: false,
  subtitleOneWords: { allWords: [], words: [] },
  handleSubtitleOneWords: () => { },
  subtitleTwoContenet: "",
  userWords: {
    userSavedWords: [],
    userLeitnerlearningLevel1: [],
    userLeitnerlearningLevel2: [],
    userLeitnerlearningLevel3: [],
    userLeitnerlearningLevel4: [],
    userLeitnerlearningLevel5: [],
    userLeitnerlearningLevel6: [],
    userLeitnerlearningLevel7: [],
    userLeitnerlearningLevel8: [],
    userLeitnerlearningLevel9: [],
  },
  handleUserWords: () => { },
  userWordsDifficultyLevel: { words: [], levels: [] },
  handleUserWordsDifficultyLevel: () => { },
  subWordLearningStyles: {},
  handleSubWordLearningStyles: () => { },
  subWordCEFRStyles: {},
  handleSubWordCEFRStyles: () => { },
  cferWordsLevel: { words: [], levels: [] },
  handleCferWordsLevel: () => { },
  subtitleStylesData: [
    {
      key: "1",
      subNumber: "اول",
      hidden: false,
      name: "1",
      fontSize: 10,
      color: "rgba(4, 187, 38, 0.5)",
      backGroundColor: "rgba(4, 187, 38, 0.5)",
    },
    {
      key: "2",
      subNumber: "دوم",
      hidden: false,
      name: "2",
      fontSize: 15,
      color: "rgba(4, 187, 38, 0.5)",
      backGroundColor: "rgba(4, 187, 38, 0.5)",
    },
  ],
  handleSubtitleStylesData: () => { },
  handlePageNumber: () => { },
  allSubtitleOne:[],
  allSubtitleTwo:[],
  handleAllSubtitle: () => { },
});
